module.exports = __webpack_public_path__ + "img/sk2.1853d9a3.svg";